import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ElementTypeSelectValue, EquipmentTypesProvider} from '@providers/equipment-types/equipment-types.provider';
import {ModelsInterfaces} from '@namespaces/models.namespace';
import {EquipmentEnums} from '@namespaces/equipment.namespace';

@Injectable()
export class EquipmentCreateOptionsService {

    private _availableTypes$ = new BehaviorSubject<ElementTypeSelectValue[]>([]);
    private _defaultGroup$ = new BehaviorSubject<ModelsInterfaces.Group>(null);
    private _defaultMethodId$ = new BehaviorSubject<number>(null);
    private _isAllObjectsByDefault$ = new BehaviorSubject<boolean>(false);

    /**
     * Безопасно ли менять модель оборудования для карточки.
     * Безопасно будет только если обязательные поля не заполнены.
     */
    private _isSafeToModelChanges$ = new BehaviorSubject<boolean>(true);

    public availableTypes$ = this._availableTypes$.pipe();
    public defaultGroup$ = this._defaultGroup$.pipe();
    public defaultMethodId$ = this._defaultMethodId$.pipe();
    public isAllObjectsByDefault$ = this._isAllObjectsByDefault$.pipe();

    constructor(
        private equipmentTypesProvider: EquipmentTypesProvider,
    ) {
        this.excludeAvailableTypes([]);
    }

    /**
     * Исключить доступные типы оборудования
     * @param typesToExclude
     */
    public excludeAvailableTypes(typesToExclude: EquipmentEnums.Type[] = []) {
        const availableTypes = this.equipmentTypesProvider.data$.getValue().filter(type => !typesToExclude.includes(type.id));
        this._availableTypes$.next(availableTypes);
    }

    /**
     * Установить доступные типы оборудования
     * @param typesToExclude
     */
    public setAvailableTypes(typesToExclude: EquipmentEnums.Type[] = []) {
        const availableTypes = this.equipmentTypesProvider.data$.getValue().filter(type => typesToExclude.includes(type.id));
        this._availableTypes$.next(availableTypes);
    }

    public setDefaultGroup(group: ModelsInterfaces.Group = null) {
        this._defaultGroup$.next(group);
    }

    public setAllObjectsByDefault(isAll = false) {
        this._isAllObjectsByDefault$.next(isAll);
    }

    public setDefaultMethod(methodId: number) {
        this._defaultMethodId$.next(methodId);
    }

    public setSafeModelChangeStatus(isSafe: boolean) {
        this._isSafeToModelChanges$.next(isSafe);
    }

    get safeModelChangeStatus(): boolean {
        return this._isSafeToModelChanges$.getValue();
    }
}
